import React from 'react';
export function UpsellTable() {
  const projects = ['Proyecto 1: Vivienda Unifamiliar Completa.', 'Proyecto 2: Local Comercial con Automatización Básica.', 'Proyecto 3: Tablero de Transferencia para Generador de Emergencia.'];
  return <section className="py-10 px-4 bg-brand-card" data-id="element-178">
      <div className="max-w-xl mx-auto" data-id="element-179">
        <div className="text-center mb-6" data-id="element-180">
          <h2 className="text-xl font-black text-white mb-4" data-id="element-181">
            🔥 INCLUYE: EL SISTEMA DE PROYECTOS FINALES INTEGRADORES
          </h2>
          <p className="text-sm text-gray-300 leading-relaxed mb-6" data-id="element-182">
            Esto convierte tu cierre de año en una{' '}
            <span className="text-brand-accent font-bold" data-id="element-183">
              EXPERIENCIA DE OBRA REAL
            </span>
            . Tus alumnos integran todo lo aprendido en proyectos completos
            listos para entregar:
          </p>
        </div>

        <div className="bg-brand-dark rounded-md border border-white/10 p-5" data-id="element-184">
          <ul className="space-y-4" data-id="element-185">
            {projects.map((project, i) => <li key={i} className="flex items-start text-sm font-bold text-white" data-id="element-186">
                <span className="text-brand-accent mr-2" data-id="element-187">👉</span>
                <span data-id="element-188">{project}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}